module.exports = __webpack_public_path__ + "img/login.18ab51fa.svg";